export const USER_PUBLIC_ID = 'public_id';

export enum DefaultResponse {
  Success = 'Success',
  Error = 'Error',
}
